(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".more").forEach(function (btn) {
  btn.addEventListener("click", function () {
    var textmore = document.querySelector(".text-more");
    var textfull = document.querySelector(".text-full");
    if (!textmore || !textfull) return;
    if (btn.classList.contains("toClose")) {
      textfull.style.height = "0px";
      textmore.style.height = textmore.scrollHeight + "px";
      btn.classList.remove("toClose");
      btn.textContent = "Read more";
    } else {
      textmore.style.height = "0px";
      textfull.style.height = textfull.scrollHeight + "px";
      btn.classList.add("toClose");
      btn.textContent = "Show Less";
    }
    var title = document.querySelector(".category-description-content-title");
    if (title) title.scrollIntoView();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh_header_ccm_mobile"]) return;
  try {
    
  function ccmSlideToggle(el, duration) {
    duration = duration || 200;
    var hidden = window.getComputedStyle(el).display === "none";
    if (hidden) {
      el.style.display = "block";
      el.style.overflow = "hidden";
      var anim = el.animate([{ height: "0px" }, { height: el.scrollHeight + "px" }], { duration: duration });
      anim.onfinish = function () { el.style.overflow = ""; el.style.height = ""; };
    } else {
      el.style.overflow = "hidden";
      var animOut = el.animate([{ height: el.scrollHeight + "px" }, { height: "0px" }], { duration: duration });
      animOut.onfinish = function () { el.style.display = "none"; el.style.overflow = ""; el.style.height = ""; };
    }
  }

  document.querySelectorAll(".ccm-mobile-menu .close").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".ccm-mobile-menu").forEach(function (menu) {
        menu.classList.toggle("active");
      });
    });
  });

  document.querySelectorAll(".ccm-mobile-menu .sub-menu-title").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      el.classList.toggle("active");
      var subMenu = el.closest(".sub-menu");
      if (!subMenu) return;
      subMenu.querySelectorAll(".dropdown-wrap").forEach(function (wrap) {
        ccmSlideToggle(wrap);
      });
    });
  });

  document.querySelectorAll(".ccm-mobile-menu .top-menu .menu-item > a").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var tabId = link.dataset.tabId;

      document.querySelectorAll(".ccm-mobile-menu .top-menu .menu-item").forEach(function (item) {
        item.classList.remove("active");
      });
      var ownItem = link.closest(".menu-item");
      if (ownItem) ownItem.classList.add("active");

      document.querySelectorAll(".ccm-mobile-menu .menu .menu-item").forEach(function (item) {
        item.classList.remove("active");
      });
      document.querySelectorAll(".ccm-mobile-menu .menu .menu-item[data-tab-id='" + tabId + "']").forEach(function (item) {
        item.classList.add("active");
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
